import { render } from "./Registrar.vue?vue&type=template&id=2ccb9246&scoped=true"
import script from "./Registrar.vue?vue&type=script&lang=js"
export * from "./Registrar.vue?vue&type=script&lang=js"

import "./Registrar.vue?vue&type=style&index=0&id=2ccb9246&scoped=true&lang=css"

import exportComponent from "F:\\Projetos VueJs\\agenda\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ccb9246"]])

export default __exports__